module.exports = __webpack_public_path__ + "img/122.018bb7f9.png";